// Util di formato condivisi tra i frame chat PA (desktop WorkspaceShell e
// MobileShell) e i sotto-componenti presentazionali. Unica fonte di verità:
// estratti da WorkspaceShell così desktop e mobile non divergono mai.

export function formatRelativeTime(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const diff = Date.now() - d.getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return 'ora';
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h`;
  const dd = Math.floor(h / 24);
  if (dd < 7) return `${dd}g`;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
}

// Rimuove i blocchi `<artifact …>…</artifact>` dal testo mostrato in chat:
// l'artefatto viene renderizzato come card/pannello dedicato, mai come XML grezzo
// inline. Su testo persistito (`streaming=false`) rimuove SOLO i blocchi completi,
// per non troncare contenuto legittimo che contiene letteralmente `<artifact` (es.
// code block o documentazione). In streaming (`streaming=true`) gestisce anche il
// tag di apertura arrivato prima della chiusura (taglia da lì) e i prefissi
// parziali del tag a fine token.
export function stripWorkspaceArtifacts(text: string, streaming = false): string {
  if (!text) return text;
  let out = text.replace(/<artifact\b[^>]*>[\s\S]*?<\/artifact>/gi, '');
  if (streaming) {
    const open = out.search(/<artifact\b/i);
    if (open !== -1) out = out.slice(0, open);
    out = out.replace(/<(?:a(?:r(?:t(?:i(?:f(?:a(?:c(?:t)?)?)?)?)?)?)?)?$/i, '');
  }
  return out.replace(/\n{3,}/g, '\n\n').replace(/[ \t]+$/gm, '').trimEnd();
}
